
import packagejson from '../../../package.json';

const  COMMON= {
  APP_VERSION: packagejson.version,
  APP_NAME: packagejson.name,
  openAIBaseUrl: 'https://apis.apiworks.com.au/v1/openai/',
};

export const ENVIRONMENTS = {
 
  PRODUCTION: {
    ...COMMON,
    name: 'Production',
    koganAPIBaseUrl: 'https://apis.apiworks.com.au/v1/koganapi/',
    s3APIBaseUrl: 'https://apis.apiworks.com.au/v1/koganapi/',
    s3PublicUrl: 'https://truvana.s3.ap-southeast-2.amazonaws.com/images/',
    amplifyConfig: {
        aws_cognito_region: 'ap-southeast-2',
        aws_user_pools_id: 'ap-southeast-2_dMt4lInS9',
      aws_user_pools_web_client_id: 'l418r9bv6ts5nm5q4sgtmhc0s',
      },
  },
  DEVELOPMENT: {
    ...COMMON,
    name: 'Development',
    koganAPIBaseUrl: 'http://localhost:8080/koganapi/',
    s3APIBaseUrl: 'https://apis.apiworks.com.au/v1/koganapi/',
    s3PublicUrl: 'https://truvana.s3.ap-southeast-2.amazonaws.com/images/',
    amplifyConfig: {
      aws_cognito_region: 'ap-southeast-2',
      aws_user_pools_id: 'ap-southeast-2_dMt4lInS9',
      aws_user_pools_web_client_id: 'l418r9bv6ts5nm5q4sgtmhc0s',
    },
  },
  PREVIEW: {
    ...COMMON,
    name: 'Preview',
    koganAPIBaseUrl: 'https://preview-api-proxy-v2.ravdeepss.workers.dev/koganapi/',
    s3APIBaseUrl: 'https://preview-api-proxy-v2.ravdeepss.workers.dev/koganapi/',
    s3PublicUrl: 'https://mastersync-preview-truvana.s3.ap-southeast-2.amazonaws.com/images/',
    amplifyConfig: {
      aws_cognito_region: 'ap-southeast-2',
      aws_user_pools_id: 'ap-southeast-2_dMt4lInS9',
      aws_user_pools_web_client_id: 'l418r9bv6ts5nm5q4sgtmhc0s',
    },
  },
};

const envMap = {
  preview: ENVIRONMENTS.PREVIEW,
  production: ENVIRONMENTS.PRODUCTION,
};

export default envMap[process.env.REACT_APP_ENV || process.env.NODE_ENV] || ENVIRONMENTS.DEVELOPMENT;
